import { Box, FormControl, Typography } from "@material-ui/core";
import { StyledCellText } from "@remar/shared/dist/components/Table/styles";
import styled from "styled-components";

import { IconListSvg } from "assets/icons";

export const Container = styled.div`
	min-height: 100vh;
	width: 100%;
	.breadcrum-container {
		div {
			font-size: 13px;
			line-height: 1.23;
			color: rgba(255, 255, 255, 0.6);
		}

		div:last-child {
			color: #ffffff;
		}
	}
`;

export const HeaderContainer = styled.div`
	margin-bottom: 24px;
	display: flex;
	margin-top: 24px;
`;

export const Heading = styled(Typography)`
	opacity: 0.87;
	font-size: 18px;
	font-weight: bold;
	font-family: var(--poppins);
	line-height: 1.33;
	color: #ffffff;
`;

export const Header = styled(Typography)`
	font-size: 18px;
	font-weight: bold;
	line-height: 1.33;
	color: #ffffff;
	flex: 1;
`;

export const THeaderWrapper = styled(Box)`
	display: flex;
	align-items: center;
	background-color: #22252d;
	padding: 20px;
	border-radius: 4px;
`;

export const TFormControl = styled(FormControl)`
	flex: 1;
	> div {
		width: fit-content;
	}
`;

export const NameWrapper = styled(Box)`
	display: flex;
	flex-direction: row;
	.left_section {
		display: flex;
		align-items: center;

		.logo {
			width: 40px;
			height: 40px;
			margin-right: 20px;
		}
	}
	.right_section {
		flex-direction: column;
		p {
			margin: 0;
			margin-bottom: 2px;
		}
	}
`;

export const StyledListIcon = styled(IconListSvg)`
	path {
		fill: ${({ theme }) => theme.palette.colors.basic[1250]};
	}
`;

export const StyledCellTextCentered = styled(StyledCellText)`
	margin: auto;
`;
